const STORAGE_KEY = 'surfstr_cookie_consent';

const getStoredConsent = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const setStoredConsent = (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Ignore write failures; banner still hides for this session.
  }
};

const initSurfstrConsent = () => {
  const holder = document.getElementById('surfstr-cookie-consent');
  if (!holder) return;

  const acceptButton = holder.querySelector('[data-surfstr-consent-accept]');
  const declineButton = holder.querySelector('[data-surfstr-consent-decline]');

  const hideBanner = () => {
    holder.hidden = true;
    holder.setAttribute('aria-hidden', 'true');
  };

  const showBanner = () => {
    holder.hidden = false;
    holder.removeAttribute('hidden');
    holder.setAttribute('aria-hidden', 'false');
  };

  const savedConsent = getStoredConsent();
  if (savedConsent) {
    hideBanner();
    if (savedConsent === 'accepted') {
      window.dispatchEvent(new Event('surfstr:consent-granted'));
    }
    return;
  }

  showBanner();

  const handleSave = (value) => {
    setStoredConsent(value);
    hideBanner();
    if (value === 'accepted') {
      window.dispatchEvent(new Event('surfstr:consent-granted'));
    }
  };

  if (acceptButton) {
    acceptButton.addEventListener('click', () => handleSave('accepted'));
  }

  if (declineButton) {
    declineButton.addEventListener('click', () => handleSave('declined'));
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSurfstrConsent);
} else {
  initSurfstrConsent();
}
